import { render, staticRenderFns } from "./DeviceInformation.vue?vue&type=template&id=676514c9"
import script from "./DeviceInformation.vue?vue&type=script&lang=js"
export * from "./DeviceInformation.vue?vue&type=script&lang=js"
import style0 from "./DeviceInformation.vue?vue&type=style&index=0&id=676514c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports